var initState = {
  metamask: {},
  userAuth: {}
}

export default initState